import { cn } from '@repo/shared-client/lib/utils'
import { useTranslation } from '@web/src/lib/intl/react'
import { forwardRef } from 'react'

import SFSpinner from '../sf-spinner/sf-spinner'

type SFPageLoadingProps = React.ComponentProps<'div'>

const SFPageLoading = forwardRef<HTMLDivElement, SFPageLoadingProps>((props, forwardedRef) => {
  const { className, ...rest } = props
  const { t } = useTranslation()

  return (
    <div
      className={cn('mx-auto flex w-full max-w-6xl flex-col items-center gap-4 py-40', className)}
      ref={forwardedRef}
      {...rest}
    >
      <div className="flex w-full justify-center">
        <SFSpinner size="md" />
      </div>
      <div className="flex w-full justify-center">
        <span className="text-muted-foreground">{t('Loading')}</span>
      </div>
    </div>
  )
})

SFPageLoading.displayName = 'SFPageLoading'

export default SFPageLoading
